<template lang="html">
  <div class="col-lg-9 col-page-content page-style-2">
    <div class="row">
      <form role="form" class="form-horizontal" @submit.prevent="onSubmitBanner($event.target)">
        <div class="col-12">
          <div class="box-bubble">
            <div class="row">

              <div class="col-12 box-acc-title-s1">
                <h4>Imagen de cabecera</h4>
                <hr />
                <p style="text-align: center;">Se sugiere una imagen formato JPG con hasta 5 MB de tamaño.</p>
              </div>

              <div class="box-profile-image">
                <b-form-group class="col-lg-12 mb-0 custom-f-group-1">
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0 pb-0">Imagen actual</legend>
                </b-form-group>

                <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+$root.user.usercompany.imageUrlBanner+')' }">
                  <a class="trans-150 btn-img-del" @click="deleteImage">Eliminar</a>
                </div>
                <br><br>
                <!-- <b-form class="form-banner" @submit="onSubmitBanner"> -->
                
                  <!--<b-form-group class="col-lg-12 mb-0 custom-f-group-1" label="Nuevo imagen de perfil">
                     <b-form-file plain accept=".jpg, .png, .gif" ></b-form-file> -->
                    <input type="file" accept=".jpg,jpeg" name="image">
                  <!--</b-form-group>
                 </b-form> -->
               
              </div>

            </div>
          </div>

          <div class="mt-2 px-0 box-empty-bubble">
            <b-form-checkbox
              class="mb-3 custom-checkbox-s1"
              v-model="form.check"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
              required>
              Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
            </b-form-checkbox>

            <b-button type="submit" class="btn-HelvNeu btn-squ-cur-1 btn-send" id="btnsave">Actualizar imagen</b-button>
          </div>
        </div>
      </form>
    </div>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
        <p>{{modal.msg}}</p>
         <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        banner: null,
      },
      modal:{
          icon:null,
          msg:null,
          imagenes_id:null
      }
    }
  },

  methods: {
    onSubmitBanner(form) {
      $( "#btnsave" ).prop( "disabled", true );
      this.$refs.modalLoading.open();
      var hayImagen = true;
      //event.preventDefault();
      if(jQuery('input[type=file]')[0].files[0] == undefined){
        hayImagen = false;
      }
      if(hayImagen)
      {
          var formData = new FormData();
          formData.append("image", jQuery('input[type=file]')[0].files[0]);

          var imagenes_id = null;
          var url = "";
          var error = false;

          jQuery.ajax({
             
             url:"https://jobusco.com/api/V1.0.0/api/sync/save_img",
              type: "POST",
              headers: {
                  
              },
            processData: false,
              contentType: false,
              data: formData,
              async:false,
          })
          .done(function(data, textStatus, jqXHR) {
              console.log("HTTP Request Succeeded: " + jqXHR.status);
              console.log(data);
              imagenes_id = data.data.id;
              //url = data.data.url;
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
              console.log("HTTP Request Failed");
              //alert("Hubo un problema al guardar la imagen.");
              error = true;
          })

          if(error)
          {
            this.$parent.showMessage("Hubo un problema al subir la imagen.","warning");
            return false;
          }

          this.form.imagenes_id = imagenes_id;
          
      }
      //event.preventDefault();
      var data=tools.params(form,this.form);
  
      axios.post(tools.url("/api/admin/company/saveBanner"),data).then((response)=>{
          $( "#btnsave" ).prop( "disabled", false  );
          this.$root.auth();
          this.$refs.modalLoading.close();
          this.modal.icon = 'success';
          this.modal.msg = 'Imagen actualizada correctamente';
          this.$refs.modalAlert.open();

          
      }).catch((error)=>{
          $( "#btnsave" ).prop( "disabled", false  );
        this.$refs.modalLoading.close();
           this.modal.icon = 'error';
          this.modal.msg = 'Ocurrio un error al guardar la información';
          this.$refs.modalAlert.open();

      });
        
    },
    deleteImage(form){
       var data=tools.params(form,this.form);
        axios.post(tools.url("/api/admin/company/saveBanner"),data).then((response)=>{
          this.$root.auth();
          this.modal.icon = 'success';
          this.modal.msg = 'Imagen eliminada correctamente';
          this.$refs.modalAlert.open();

          
        }).catch((error)=>{
          
        });
    }
  },
  mounted(){
    
  }
}
</script>
